module.exports = __webpack_public_path__ + "static/img/sdny.0836dba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/sdny.png
// module id = DiFy
// module chunks = 1